import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { comparisonRows } from '../data/content';
export function Comparison() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-32" data-mp="1g8ue71hjjvos">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-33" data-mp="1l6vyfpqpe11u">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-3 font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-34" data-mp="1py46oigargdf">
          <ScaleIcon className="h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-35" data-mp="1uwxnokuslpic" />
          Método antiguo vs Atlas
        </h2>

        <div className="mx-auto mt-12 max-w-narrow overflow-x-auto rounded-2xl ring-1 ring-blue-100" data-id="element-36" data-mp="23y5942c7mvv0">
          <table className="w-full min-w-[32rem] border-collapse text-left" data-id="element-37" data-mp="28wqcubqo7xo7">
            <caption className="sr-only" data-id="element-38" data-mp="28um4nhlqoci4">
              Comparación entre el método de estudio común y el Atlas Kinesio-Visual
            </caption>
            <thead data-id="element-39" data-mp="ek0i5rshakfr">
              <tr className="bg-blue-50" data-id="element-40" data-mp="ej7gv6cagn50">
                <th scope="col" className="px-5 py-4 font-display text-sm font-extrabold text-blue-900/60 md:px-6" data-id="element-41" data-mp="1m0gzmk8qyc4c">
                  Método común
                </th>
                <th scope="col" className="bg-blue-100 px-5 py-4 font-display text-sm font-extrabold text-blue-800 md:px-6" data-id="element-42" data-mp="1d7m4ijcztwsa">
                  Atlas Kinesio-Visual
                </th>
              </tr>
            </thead>
            <tbody data-id="element-43" data-mp="20y9ct5qtmofd">
              {comparisonRows.map(row => <tr key={row.old} className="border-t border-blue-100 bg-white" data-id="element-44" data-mp="20vvjb1bshk9x">
                  <td className="px-5 py-4 text-blue-900/60 md:px-6" data-id="element-45" data-mp="1vxbwyztaa6h1">{row.old}</td>
                  <td className="bg-blue-50 px-5 py-4 font-semibold text-blue-800 md:px-6" data-id="element-46" data-mp="1qyqx51hy1ot4">
                    {row.atlas}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mx-auto mt-12 max-w-2xl font-display text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-4xl" data-id="element-47" data-mp="fmq0z1ir2y3c">
          Tu próximo examen puede ser diferente.
        </p>
      </div>
    </section>;
}